import { Typography } from 'antd';

import { MedicalCardTextRowValue } from './styledComponents';

interface MedicalCardTextRowProps {
  title: string;
  text: string;
  textShrink?: boolean;
}

const MedicalCardTextRow = ({ title, text, textShrink = false }: MedicalCardTextRowProps): JSX.Element => (
  <>
    <Typography.Text type="secondary">{title}</Typography.Text>
    <MedicalCardTextRowValue strong shrink={textShrink}>
      {text}
    </MedicalCardTextRowValue>
  </>
);

export default MedicalCardTextRow;
